"use strict";

module.exports = function (fn) {
	if (typeof fn !== "function") throw new TypeError(fn + " is not a function");
	return fn;
};



//////////////////
// WEBPACK FOOTER
// /Users/Fuunnx/workspace/zygmund/~/es5-ext/object/valid-callable.js
// module id = ../../../node_modules/es5-ext/object/valid-callable.js
// module chunks = 1